import type { StateDeclarationFn } from 'controller/types';

export default (function () {
  return [
    {
      name: 'group.custom',
      url: '/custom?',
      redirectTo: 'group.custom.tab',
    },
    {
      name: 'group.custom.tab',
      url: '/:tabId',
      data: {
        title: 'groups-web.custom',
      },
      params: {
        tabId: {
          type: 'string',
          value: 'custom_app',
          squash: true,
        },
      },
    },
  ];
} as StateDeclarationFn);
